import { render, staticRenderFns } from "./ImsAddInventoryModal.vue?vue&type=template&id=5d10e708&scoped=true&"
import script from "./ImsAddInventoryModal.vue?vue&type=script&lang=js&"
export * from "./ImsAddInventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ImsAddInventoryModal.vue?vue&type=style&index=0&id=5d10e708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10e708",
  null
  
)

export default component.exports